const dateFormatter = new Intl.DateTimeFormat("el-GR", {
  timeZone: "Europe/Athens",
});

const asText = (value) => value?.toString?.().trim?.() ?? "";

const formatDate = (value) => {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? asText(value) : dateFormatter.format(date);
};

const isVisible = (mode) => asText(mode).toLowerCase() !== "hidden";

export const getReviewCommentText = (row) =>
  asText(
    row?.statusComments ??
      row?.reviewComments ??
      row?.expStatusComments ??
      row?.ExpStatusComments ??
      row?.ReviewComments,
  );

const addField = (fields, label, value) => {
  const text = asText(value);
  if (text) fields.push(`${label}: ${text}`);
};

const getExpenseRowHeading = (row, index, modeConfig) => {
  const fields = [];

  if (isVisible(modeConfig.employeeMode)) {
    addField(fields, "Εργαζόμενος", row?.employeeFullName);
  }
  if (isVisible(modeConfig.childMode)) {
    addField(fields, "Ωφελούμενος", row?.childFullName);
  }
  if (isVisible(modeConfig.appartmentMode)) {
    addField(fields, "Διαμέρισμα", row?.appartmentName);
  }
  addField(fields, "Είδος Δαπάνης", row?.expTypeName);
  if (isVisible(modeConfig.dateFromMode)) {
    addField(fields, "Από", formatDate(row?.dateFrom));
  }
  if (isVisible(modeConfig.dateToMode)) {
    addField(fields, "Έως", formatDate(row?.dateTo));
  }

  return `${index + 1}. ${fields.join(" · ") || "Γραμμή δαπάνης"}`;
};

const getPaymentHeading = (payment, index) => {
  const number = asText(payment?.paymentNumber) || index + 1;
  const date = asText(payment?.paymentDateFormatted) || formatDate(payment?.paymentDate);
  const fields = [`Πληρωμή ${number}`];
  addField(fields, "Ημ/νία Πληρωμής", date);

  return `${index + 1}. ${fields.join(" · ")}`;
};

const formatReviewRows = (rows, getHeading) => {
  const lines = rows.flatMap((row, index) => {
    const comment = getReviewCommentText(row);
    return comment
      ? [getHeading(row, index), `Σχόλιο ελέγχου: ${comment}`]
      : [];
  });

  return lines.length ? lines : ["Δεν υπάρχουν σχόλια ελέγχου."];
};

export const buildReviewClipboardSummary = ({
  transaction,
  mhdName,
  modeConfig = {},
  expenseRows = [],
  payments = [],
}) => {
  const title = [
    asText(transaction?.mhdName) || asText(mhdName) || asText(transaction?.mhdAbbr),
    asText(transaction?.transTypeName),
    asText(transaction?.transDateFormatted) || formatDate(transaction?.transDate),
  ]
    .filter(Boolean)
    .join(" - ");

  return [
    title,
    "",
    "ΑΝΑΛΥΣΗ ΔΑΠΑΝΩΝ",
    ...(expenseRows.length
      ? formatReviewRows(expenseRows, (row, index) =>
          getExpenseRowHeading(row, index, modeConfig),
        )
      : ["Δεν υπάρχουν γραμμές δαπάνης."]),
    "",
    "ΠΛΗΡΩΜΕΣ",
    ...(payments.length
      ? formatReviewRows(payments, getPaymentHeading)
      : ["Δεν υπάρχουν πληρωμές."]),
  ].join("\n");
};
